import React from 'react';

import { useT } from '../context/LanguageContext';

const NotFoundPage = () => {
  const { t } = useT();
  return (
    <div className="container-fluid d-flex py-5 justify-content-center align-items-start text-center">
      <p className="my-0 py-5 text-muted mw-32em">
        {t('error.notfound.message')}
      </p>
    </div>
  );
};

export default NotFoundPage;
